<template>
  <div class="cookie-info">
    <div class="float slim">
      <h2>Kakor</h2>
      <p
        class="cookie-info-preamble"
      >När du besöker lemodikrysset.se lagras kakor på din dator. Dessa kakor används av webbläsaren för att kunna fungera på korrekt sätt.</p>
      <br />
      <h3>Kakor på lemodikrysset.se</h3>
      <br />
      <h3>Sessionskakor</h3>
      <p>Sessionskakor ligger kvar på din dator när du stänger webbläsaren.</p>
      <br />
      <p>
        <b>_lemodi</b> är en kaka som håller information om den nuvarande sessionen. Kakan ligger på din dator i 24 timmar.
      </p>
      <p>
        <b>cookiesConsent</b> innehåller information om huruvida du godkänner kakor. Sparas i ett år.
      </p>
      <br />
      <h3>Varaktiga kakor</h3>
      <p>Lemodikrysset.se använder Google Analytics för att samla in användningsstatistik.</p>
      <br>
      <p><b>_ga</b> används för att kunna skilja på unika och återkommande användare. Kakan sparas i 2 år.</p>
      <p><b>_gid</b> används för att urskilja unika användare. Kakan sparas i 24 timmar.</p>
      <p><b>_gat</b> används för att begränsa antalet anrop. Kakan sparas i en(1) minut efter att den skapats eller att sidan senast uppdaterades.</p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>